(function () {
  // Pas hier de tiers aan: { minTotalQty: aantalGratisTeKiezen }
  var GWP_TIERS = { 2: 2, 3: 5 };
  var SAMPLE_CAP = 3;
  var GIFT_PROPERTY = '_gift';

  function getAllowedCount(qty) {
    var keys = Object.keys(GWP_TIERS).map(Number).sort(function (a, b) { return a - b; });
    var allowed = 0;
    for (var i = 0; i < keys.length; i++) {
      if (qty >= keys[i]) allowed = GWP_TIERS[keys[i]];
    }
    return allowed;
  }

  function isGiftItem(item) {
    return !!(item.properties && item.properties[GIFT_PROPERTY]);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  var modal, confirmBtn;
  var selection = {}; // handle -> qty
  var itemsByHandle = {}; // handle -> { variantId, row, group, available, valueEl }
  var groups = {}; // group -> { allowed, allowedEl, selectedEl }

  function init() {
    modal = document.getElementById('gwp-modal');
    if (!modal) return;
    confirmBtn = modal.querySelector('#gwp-confirm');

    modal.querySelectorAll('[data-gwp-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    modal.querySelectorAll('.gwp-section').forEach(function (section) {
      var group = section.getAttribute('data-gwp-section');
      groups[group] = {
        allowed: group === 'sample' ? SAMPLE_CAP : 0,
        allowedEl: section.querySelector('[data-gwp-allowed-count]'),
        selectedEl: section.querySelector('[data-gwp-selected-count]')
      };
    });

    modal.querySelectorAll('.gwp-item').forEach(function (row) {
      var handle = row.getAttribute('data-gwp-handle');
      var variantId = row.getAttribute('data-gwp-variant-id');
      var available = row.getAttribute('data-gwp-available') === 'true';
      var group = row.getAttribute('data-gwp-group');
      itemsByHandle[handle] = { variantId: variantId, row: row, group: group, available: available, valueEl: row.querySelector('[data-gwp-qty-value]') };
      selection[handle] = 0;

      if (!available) return;

      row.querySelector('[data-gwp-qty-up]').addEventListener('click', function () {
        if (totalSelectedInGroup(group) >= groups[group].allowed) return;
        selection[handle]++;
        render();
      });
      row.querySelector('[data-gwp-qty-down]').addEventListener('click', function () {
        if (selection[handle] <= 0) return;
        selection[handle]--;
        render();
      });
    });

    confirmBtn.addEventListener('click', confirmSelection);

    bindActieTrigger();
    checkCartNow();
    hookSlideCartUpdated();

    ['cart:changed', 'slidecart:updated'].forEach(function (evt) {
      window.addEventListener(evt, function () { checkCartNow(); });
    });
  }

  function closeSlideCart() {
    if (typeof window.SLIDECART_CLOSE === 'function') {
      window.SLIDECART_CLOSE();
      return;
    }
    var overlay = document.querySelector('#slidecarthq .amp-sc__overlay, .amp-sc__overlay');
    if (overlay) {
      overlay.click();
      return;
    }
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
  }

  function bindActieTrigger() {
    var btn = document.getElementById('actietrigger');
    if (btn) {
      btn.addEventListener('click', function () {
        closeSlideCart();
        open();
      });
      return;
    }
    setTimeout(bindActieTrigger, 300);
  }

  function hookSlideCartUpdated() {
    (function wait() {
      if (typeof window.SLIDECART_UPDATED === 'function') {
        var original = window.SLIDECART_UPDATED;
        if (original.__gwpWrapped) return;
        window.SLIDECART_UPDATED = function (cart) {
          var result = original.apply(this, arguments);
          handleCart(cart);
          return result;
        };
        window.SLIDECART_UPDATED.__gwpWrapped = true;
      } else {
        setTimeout(wait, 300);
      }
    })();
  }

  function checkCartNow() {
    fetchCart().then(handleCart);
  }

  function isQualifyingItem(item) {
    var ids = window.GWP_QUALIFYING_PRODUCT_IDS || [];
    return ids.indexOf(item.product_id) !== -1;
  }

  function handleCart(cart) {
    if (!cart || !cart.items) return;
    var nonGiftQty = 0, giftQtyByVariant = {};
    cart.items.forEach(function (item) {
      if (isGiftItem(item)) {
        giftQtyByVariant[item.variant_id] = (giftQtyByVariant[item.variant_id] || 0) + item.quantity;
      } else if (isQualifyingItem(item)) {
        nonGiftQty += item.quantity;
      }
    });

    groups.gift.allowed = getAllowedCount(nonGiftQty);
    groups.sample.allowed = SAMPLE_CAP;

    Object.keys(itemsByHandle).forEach(function (handle) {
      var variantId = Number(itemsByHandle[handle].variantId);
      selection[handle] = giftQtyByVariant[variantId] || 0;
    });

    var giftGroupTotalInCart = totalSelectedInGroup('gift');

    render();

    var lastOpenedFor = Number(sessionStorage.getItem('gwp_last_auto_opened_for') || '0');
    if (groups.gift.allowed > 0 && groups.gift.allowed > giftGroupTotalInCart && groups.gift.allowed !== lastOpenedFor) {
      sessionStorage.setItem('gwp_last_auto_opened_for', String(groups.gift.allowed));
      closeSlideCart();
      open();
    }
  }

  function totalSelectedInGroup(group) {
    return Object.keys(itemsByHandle).reduce(function (sum, handle) {
      return itemsByHandle[handle].group === group ? sum + selection[handle] : sum;
    }, 0);
  }

  function render() {
    if (!modal) return;

    Object.keys(groups).forEach(function (group) {
      var total = totalSelectedInGroup(group);
      groups[group].allowedEl.textContent = groups[group].allowed;
      groups[group].selectedEl.textContent = total;
    });

    var grandTotal = Object.keys(selection).reduce(function (sum, h) { return sum + selection[h]; }, 0);
    confirmBtn.disabled = grandTotal === 0;

    Object.keys(itemsByHandle).forEach(function (handle) {
      var entry = itemsByHandle[handle];
      if (!entry.available) return;
      entry.valueEl.textContent = selection[handle];
      var upBtn = entry.row.querySelector('[data-gwp-qty-up]');
      var downBtn = entry.row.querySelector('[data-gwp-qty-down]');
      var groupTotal = totalSelectedInGroup(entry.group);
      upBtn.disabled = groupTotal >= groups[entry.group].allowed;
      downBtn.disabled = selection[handle] <= 0;
    });
  }

  function open() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function confirmSelection() {
    confirmBtn.disabled = true;
    fetchCart().then(function (cart) {
      var removals = cart.items
        .filter(isGiftItem)
        .map(function (item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        });

      return Promise.all(removals);
    }).then(function () {
      var items = Object.keys(selection)
        .filter(function (handle) { return selection[handle] > 0; })
        .map(function (handle) {
          var props = {};
          props[GIFT_PROPERTY] = 'true';
          return {
            id: Number(itemsByHandle[handle].variantId),
            quantity: selection[handle],
            properties: props
          };
        });

      if (items.length === 0) return Promise.resolve();

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      });
    }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      handleCart(cart);
      window.dispatchEvent(new CustomEvent('cart:changed'));
      window.dispatchEvent(new CustomEvent('slidecart:updated'));
      close();
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      setTimeout(function () {
        if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
      }, 600);
    }).catch(function (err) {
      console.error('GWP: kon gifts niet bijwerken', err);
    }).finally(function () {
      confirmBtn.disabled = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
